import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import TableRefuses from './components/TableRefuses';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import Help from '../generics/help';

var Config = require('../../config');

class Refuses extends Component{
	constructor(props){
		super(props);
		
		this.getRefuses = this.getRefuses.bind(this);

		this.state = {
			list_refused:[],
			donors:[],
			isLoading:false,
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	_handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donors/with_incidents?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ response[i].birthday;;
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ response[i].birthday;;
					}

					if(response[i].document !== null){							
						response[i].names +=' '+response[i].document_type_value;
						response[i].names +=' '+response[i].document_number;
						
					}
					response[i].id = response[i].donor_id;
				};
				
				this.setState({
					isLoading: false,
			      	donors: response
			    });
			}
		})
	}

	getRefuses(values){
	    
	    if (values.length > 0) {
	      	var value = values[0].donor_id;
	      
	      	this.props.waiting.handleShow('Cargando...');
	      	fetch(Config.default.apiGateway.URL+'incidents_refused/by_donor?donor_id='+value, {
	      		method:'GET',
	      		headers: new Headers({
	      			'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
	      			'Accept'		: 'application/json',
	      			'Content-Type'	: 'application/json'
	      		})
	      	}).then(res => {
	      		this.props.waiting.handleClose();
	      		if(res.ok){
	      			return res.json();
	      		}else{
	      			res.text().then((msg)=>{
	      				swal('Error', msg, 'error');
	      			});
	      		}
	      	}).then(response => {
	      		if(response !== undefined){
	      			this.setState({list_refused:response.res});
	      			setTimeout(()=>{
	      				this._typeahead.getInstance().blur();
	      			}, 300)
	      			
	      		}
	      	})

	    }
	    
	}

	refresh(){
		this.setState({
			list_refused:[],
			donors:[],
			isLoading:false,
		});
		this._typeahead.getInstance().clear();
	}

	render(){
		const { t } = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					{t('sidebar.nav.donors.MAIN')} ->
					{t('sidebar.nav.donors.refuses')}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_donors"} 
	                submenu={"help_release_locks"}  />
				<div className="col-xs-12 form-group" style={{padding:"0px"}}>
					<div style={{padding:"0px"}}>
				        <div className="col-xs-8">
				 			<span className="span-min">{t('content.generics.buttons.search')}</span>
					        <AsyncTypeahead
					          /*{...this.state}*/
					          labelKey={(option) => `${option.names}`}
					          minLength={3}
					          maxLength={50}
					          name="patient"
					          id="patient"
					          onSearch={this._handleSearchDonor}
					          placeholder="Buscar por apellidos más nombre o número de documento..."
					          options={this.state.donors}
					          onChange={this.getRefuses}
					          ref={ref => this._typeahead = ref}
					          useCache={false}
					          isLoading={this.state.isLoading}
					          delay={600}
					          paginationText="Mostrar mas resultados..."
					        />
					 			
						</div>
				    </div>
				    
				</div>


				<div className="form-group">
					<TableRefuses 
						{...this.props}
						onRef={ref => (this.table_refuses = ref) }
						refuses={this.state.list_refused}
						refresh={this.refresh} />
				</div>
			</div>
		)
	}
}

export default translate('translations')(Refuses);
